import { SeasonEnum, TornEnum } from '../../types/productSchema';

type ReturnTypeGetTextSeason = 'Зима' | 'Лето' | '';
type ReturnTypeGetTextSeasonTyres = 'Зимние' | 'Летние' | '';
type ReturnTypeGetTextTornTyres = 'Шипованные' | 'Нешипованные' | '';

export const getTextSeason = (season: SeasonEnum): ReturnTypeGetTextSeason => {
  switch (season) {
    case SeasonEnum.Winter:
      return 'Зима';
    case SeasonEnum.Summer:
      return 'Лето';
    default:
      return '';
  }
};

export const getTextSeasonTyres = (season: SeasonEnum): ReturnTypeGetTextSeasonTyres => {
  switch (season) {
    case SeasonEnum.Winter:
      return 'Зимние';
    case SeasonEnum.Summer:
      return 'Летние';
    default:
      return '';
  }
};

export const getTexTornTyres = (torn: TornEnum): ReturnTypeGetTextTornTyres => {
  switch (torn) {
    case TornEnum.Torn:
      return 'Шипованные';
    case TornEnum.NoTorn:
      return 'Нешипованные';
    default:
      return '';
  }
};
